
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "apiBaseUrl": "https://api.vkusilosos.ru",
  "env": "production",
  "nuxt": {
    "buildId": "f6e7b95f-df81-4ec8-a89d-1270a9ff2fe4"
  },
  "__swiper": {
    "bundled": true
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
